import { Modal, ModalClose } from '@uswitch/spark.modal'
import { Overlay } from '@uswitch/spark.overlay'

import * as st from './styles'

const defaultOnClose = () => {}

const BaseModal = ({ title, isOpen, setOpen, onClose = defaultOnClose, children }) => {
  return (
    <Modal
      title={title}
      closeButton={
        <div sx={st.modalClose}>
          <ModalClose
            onClick={() => {
              onClose()
              setOpen(false)
            }}
          />
        </div>
      }
      overlay={
        <Overlay
          enabled={isOpen}
          onClick={() => {
            onClose()
            setOpen(false)
          }}
        />
      }
    >
      {children}
    </Modal>
  )
}

export default BaseModal
